import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useModal } from '../context/ModalContext';

const Hero = () => {
  const { openModal } = useModal();

  return (
    <section className="hero">
      <div className="hero-bg"></div>
      <div className="container hero-content">
        <div className="hero-text animate-fade-in">
          <h1>Building Scalable Digital Systems for Businesses and Institutions</h1>
          <p>
            Le-Ma Systems designs, develops, and deploys secure, high-performance
            digital solutions tailored for growth, efficiency, and real-world impact.
          </p>
          <div className="hero-actions">
            <button className="btn btn-primary" onClick={openModal}>
              Start a Project <ArrowForwardIcon fontSize="small" style={{ marginLeft: '8px' }} />
            </button>
            <button className="btn btn-outline" style={{ border: 'none' }}>
              <PlayCircleOutlineIcon style={{ marginRight: '8px', fontSize: '28px' }} /> Discover Le-Ma Systems
            </button>
          </div>
        </div>
        {/* <div className="hero-image animate-fade-in" style={{ animationDelay: '0.2s' }}>
          <img src="/assets/hero-mockup.jpg" alt="Le-Ma Systems Dashboard Mockups" />
        </div> */}
      </div>
    </section>
  );
};

export default Hero;
